// client/src/Message.js

import React from 'react';
import StreamedImage from './StreamedImage';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const SenderIcon = ({ sender, brandConfig  }) => {
    // ... (This component doesn't need to change)
    if (sender === 'ai') {
        return (
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white flex items-center justify-center shadow-sm">
            <img src={brandConfig.bubbleIcon} alt={`${brandConfig.displayName} Assistant Logo`} className="w-full h-full object-cover rounded-full" />
          </div>
        );
    }
    return (
        <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold bg-gray-700 text-white">
          👤
        </div>
    );
};

// --- THIS IS A NEW, SMALL COMPONENT FOR THE ANIMATION ---
const TypingAnimation = () => (
    <div className="flex items-center space-x-1">
        <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-pulse [animation-delay:-0.3s]"></span>
        <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-pulse [animation-delay:-0.15s]"></span>
        <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-pulse"></span>
    </div>
);

function Message({ sender, text, onImageClick, brandConfig, rewrittenQuery, rewrittenLabel }) {
    const isUser = sender === 'user';
    
    // --- NEW LOGIC: Check if this is an empty AI message ---
    const isTyping = sender === 'ai' && text.trim() === '';

    const parseAndRenderText = (inputText) => {
        // ... (this function does not need to change)
        const regex = /<img-reference:\s*(.*?)\s*>/g;
        const parts = inputText.split(regex);
        return parts.map((part, index) => {
            if (index % 2 === 1) {
                return <StreamedImage key={index} imageId={part} onImageClick={onImageClick} />;
            }
            if (!part.trim()) return null;
            return (
                <ReactMarkdown
                    key={index}
                    remarkPlugins={[remarkGfm]}
                    components={{
                        h3: ({node, ...props}) => <h3 className="text-lg font-semibold mt-4 mb-2" {...props} />,
                        ol: ({node, ...props}) => <ol className="list-decimal list-inside pl-4 space-y-2" {...props} />,
                        ul: ({node, ...props}) => <ul className="list-disc list-inside pl-4 space-y-2" {...props} />,
                        li: ({node, ...props}) => <li className="pl-2" {...props} />,
                        strong: ({node, ...props}) => <strong className="font-bold" {...props} />,
                        p: ({node, ...props}) => <p className="mb-2 last:mb-0" {...props} />,
                    }}
                >{part}</ReactMarkdown>
            );
        });
    };

    return (
        <div className={`flex items-start gap-4 p-4 ${isUser ? 'flex-row-reverse' : ''}`}>
            <SenderIcon sender={sender} brandConfig={brandConfig} />
            <div className={`flex flex-col gap-1 ${isUser ? 'items-end' : 'items-start'}`}>
                <p className="text-sm text-gray-500">{isUser ? 'You' : brandConfig.assistantName}</p>
                {!isUser && rewrittenQuery && (
                    <div className="max-w-lg rounded-lg border border-blue-200 bg-blue-50 px-3 py-2">
                        <p className="text-xs font-semibold uppercase tracking-wide text-blue-700">
                            🔍 {rewrittenLabel}
                        </p>
                        <p className="text-sm italic text-blue-900">« {rewrittenQuery} »</p>
                    </div>
                )}
                <div className={`
                    flex flex-col items-start
                    max-w-lg rounded-xl px-4 py-3 break-words
                    ${isUser ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800'}
                `}>
                    {/* --- CONDITIONAL RENDERING --- */}
                    {isTyping ? <TypingAnimation /> : parseAndRenderText(text)}
                </div>
            </div>
        </div>
    );
}

export default Message;